import { VStack } from '@ayble-health/dashboard-components';
import { SideNavButton } from './SideNavButton';
import { SideNavLocation } from './types';
import styled from '@emotion/styled';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import type { EmotionTheme } from '../../theme/emotionTheme';

const GradientBox = styled('div')<{ theme?: EmotionTheme }>`
  background-image: ${({ theme }) =>
    `linear-gradient(to bottom, ${theme.colors.secondary['500']}, ${theme.colors.secondary['200']})`};
`;

const { REACT_APP_HEALTHIE_URL } = process.env;

const normalizeLocation = (location: SideNavLocation) => {
  switch (location) {
    case SideNavLocation.Home:
      return '/tasks';
    case SideNavLocation.Care:
      return '/hc-dashboard';
    case SideNavLocation.Support:
      return '/support';
    default:
      throw new Error(`Unknown location: ${location}`);
  }
};

export const SideNav = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const changeLocation = useCallback(
    (location: SideNavLocation) => {
      if (location === SideNavLocation.Labs) {
        window.open(`${REACT_APP_HEALTHIE_URL}/lab_orders`, 'healthie');
        return;
      }
      const normalizedLocation = normalizeLocation(location);
      navigate(normalizedLocation);
    },
    [navigate]
  );

  return (
    <GradientBox>
      <VStack
        alignItems={'center'}
        justifyContent={'space-between'}
        h={'100%'}
        w={'64px'}
      >
        <VStack>
          <SideNavButton
            isSelected={pathname.includes('/tasks')}
            location={SideNavLocation.Home}
            onLocationSelect={changeLocation}
          />
          <SideNavButton
            isSelected={
              pathname.includes('/hc-dashboard') ||
              pathname.includes('/user-details')
            }
            location={SideNavLocation.Care}
            onLocationSelect={changeLocation}
          />
          <SideNavButton
            isSelected={false}
            location={SideNavLocation.Labs}
            onLocationSelect={changeLocation}
          />
        </VStack>

        <SideNavButton
          isSelected={pathname.includes(SideNavLocation.Support.toLowerCase())}
          location={SideNavLocation.Support}
          onLocationSelect={changeLocation}
        />
      </VStack>
    </GradientBox>
  );
};
